// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

function initSwiper(){
  var cardSlider = new Swiper('.slider_scroll_sellingnow', {
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    slidesPerView: 1.2,
    spaceBetween: 30,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1260: {
        slidesPerView: 3,
      }
    }
  });
}

jQuery(document).ready(function() {
  setTimeout(function(){
     initSwiper();
  }, 200);
});
